// This helper is mainly used in navigateForm Vue methods. It is used to remove invalid DOM elements from
// the "elements" object returned when calling document.getElementById(`${idPrefix}-${targetId}`).getElementsByTagName('*').
// "Invalid DOM elements" includes icons (elements with class names such as 'el-input__icon' or 'el-icon-date') or
// other elements that occupy key "0" of the "elements" object. In a nutshell, if the object at elements[0] is not a
// focusable field, then arrow key navigation won't work...
export default (elements, classesToLookFor) => {
  let validElements = []
  for (let el in elements) {
    if (!elements.hasOwnProperty(el)) {
      continue
    }
    classesToLookFor.map((v) => {
      if (elements[el].className.includes(v)) {
        validElements.push(elements[el])
      }
    })
  }
  return validElements
}



// WEBPACK FOOTER //
// ./src/utils/helpers/FilterInvalidDOMElements.js